// src/graphql/customQueries.js
import { gql } from 'graphql-tag';

export const getCustomerCheckInWithSignature = gql`
  query GetCustomerCheckIn($id: ID!) {
    getCustomerCheckIn(id: $id) {
      id
      signatureImage
    }
  }
`;
